import { ContentWrapper, DataTable } from "@components/index";
import { Button, Pagination, Space, Spin, TableColumnsType, Typography } from "antd";
import { useEffect, useState } from "react";
import { get } from "@services/api.service";
import { useNotification } from "@hooks/useNotification";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMaskId } from "~/Hooks/useMaskId";
import { useHasAccess } from "@hooks/useHasAccess";
import { Icon } from "@iconify/react";
import styles from "../Contract.module.scss";
import { useQuery } from "~/Hooks/useQuery";
import { debounce } from "lodash";
import { useAuth } from "@hooks/useAuth";
import { UserType } from "~/Utils";
import { getFormattedDate } from "@utils/CommonUtils";

export const Templates = () => {
  const [data, setData] = useState<any>([]);
  const { hasPermissions, hasRole } = useHasAccess();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const { openToast } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  const [page, setpage] = useState<number>();
  const [orderByName, setOrderByName] = useState("createdOn");
  const [pageStart, setPageStart] = useState<number>(0);
  const navigate = useNavigate();
  const { mask } = useMaskId();
  const { user } = useAuth();
  const [searchString, setSearchString] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const query = useQuery();
  const [apiUrl, setApiUrl] = useState<any>("");

  const menuClick = (key: string, record: { [key in string]: any }) => {
    if (key === "delete") {
    }
    if (key === "edit") {
      navigate(`/templates/edit/${record.templateId}`);
    }
  };

  const tableActions = {
    callback: menuClick,
    items: [
      {
        label: (
          <Typography.Text
            type="secondary"
            style={{ color: styles.primary }}
          >
            <Space>
              <Icon
                icon="akar-icons:edit"
                inline
                fontSize={16}
                style={{ color: styles.primary }}
              />
              Edit
            </Space>
          </Typography.Text>
        ),
        key: "edit",
      },
    ],
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
    setIsLoading(isLoading);
  }, 1000);

  const getRecords = (sortOrder: string, orderByParam: string, searchString: any, currentPage?: number) => {
    setIsLoading(true);
    const url = `v1/spa/get-template-list?size=${recordsPerPage}&page=${currentPage}&order=${sortOrder}&orderBy=${orderByParam}&searchText=${encodeURIComponent(searchString)}`;
    setApiUrl(url);
    get(url)
      .then((res: any) => {
        if (res && res.status === "OK") {
          if (res.response?.data?.records) {
            setTotalRecords(res.response.data.total || 0);
            setData(res.response.data.records);
          } else {
            console.error("Data structure mismatch:", res.response);
            setData([]);
          }
        } else {
          console.error("Unexpected status:", res.status);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        openToast({
          content: "Getting Templates failed",
          type: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRecords(sortOrder, orderByName, searchString, searchString.length > 0 ? 0 : pageStart);
  }, [searchString]);

  const columns: TableColumnsType = [
    {
      title: "Template Name",
      dataIndex: "templateName",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
    {
      title: "Created at",
      dataIndex: "createdOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
    },
    {
      title: "Updated at",
      dataIndex: "updatedOn",
      render: (value: any, record: any) =>
        value ? (
          <Typography.Text>{getFormattedDate(value)}</Typography.Text>
        ) : (
          <Typography.Text disabled>-</Typography.Text>
        ),
    },
    {
      title: "Updated by",
      dataIndex: "updateBy",
      render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
    },
  ];

  const handleTableSort = (column: any, sortOrder: string, page: any) => {
    let order = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getRecords(order, column.dataIndex, searchString, pageStart);
  };

  return (
    <ContentWrapper
      title={"Templates"}
    >
      {isLoading && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      <DataTable
        columns={columns?.map((column) => ({
          ...column,
        }))}
        className="table-clickable"
        tableData={
          data
            ? data?.map((d: any, index: number) => {
                return {
                  ...d,
                  key: d.templateId,
                };
              })
            : null
        }
        tableActions={tableActions}
        showTopBar={false}
        isLoading={false}
        exportFileName="Templates"
        onClick={(record) => navigate(`/templates/view/${record.templateId}`)}
        isServerSearchApi={true}
        inputDisable={isLoading}
        isPagination={true}
        totalRecords={totalRecords}
        exportApiUrl={apiUrl}
        recordsPerPage={recordsPerPage}
        multiSelect={false}
        hideExport={true}
        searchPlaceholderText={"Search Template Name"}
      />

      <div className="pagination">
        {/* <Pagination
          defaultCurrent={1}
          total={data && totalRecords}
          onChange={(page) => {
            const startIndex = page - 1;
            setpage(page - 1);
            setPageStart(startIndex);
            getRecords(sortOrder, orderByName, searchString, startIndex);
          }}
          showSizeChanger={false}
        /> */}
      </div>
    </ContentWrapper>
  );
};
